// vue3request包
import { Request } from "@cttq/cttq-request";
import type { ResponseType } from "@cttq/cttq-request";
import { LoginResponseType, MenuType, ActionResponseType, UserType } from "./interface";
const projectCode = import.meta.env.VITE_SOURCE;
// 获取token
let serverInstance = new Request({
	// contextPath: "BASE"
});

//获取token
export function loginForSimulator( account: string ){
	return serverInstance.post<LoginResponseType>({
		url: `/dingtalk/platform/auth/loginForSimulator`,
		data: {
			account: account,
		},
	});
}
//获取用户信息
export function getUserInfo() {
	return serverInstance.get<ResponseType<Array<UserType>>>({
		url: `/acfront-web/account-center/person/selPersonDetailAndOrg`,
	});
}

//获取菜单接口
export function getUserMenu( account: string ) {
	return serverInstance.get<ResponseType<MenuType[]>>({
		url: `/acfront-web/external-common/users/${account}/apps/${projectCode}/menu?resourceCode=${projectCode}`,
	});
}

// 权限
export function getUserAction(account: string ,code: string) {
	return serverInstance.get<ActionResponseType>({
		url: `/acfront-web/external-common/users/${account}/apps/${projectCode}/action?resourceCode=${code}`,
	});
}

// 登出
export function logoutAction() {
	return serverInstance.get({
		url: `/cttq-sso-web/auth/logout`,
	});
}
